// Deactivating ANOTHER user = POST user/Update with IsActive false (company admins only; the server refuses
// 403 NOT_ALLOWED / 409 LAST_ADMIN). Never User/{id}/DeactiveUser: that route only works on the caller's own
// account (400 for anyone else) and it DELETES the account (moves the row to qats_nc_Users_history).
// user/Update writes FullName / PhoneNo / RoleId / ImageLocation as sent, so the member's current values go along.
// GET TeamMember has no FullName: its Name is FullName, or the e-mail when the name is empty - never send the
// e-mail back as the name. Its UserId is the user NAME (text), so only unique_id identifies the user.
export const buildDeactivatePayload = member => {
    const userId = Number(member?.unique_id)
    if (!Number.isInteger(userId) || userId <= 0) return null
    const roleId = Number(member?.RoleId)
    const name = member?.FullName ?? (member?.Name && member.Name !== member?.Email ? member.Name : '')
    return {
        UserId: userId,
        FullName: name || '',
        PhoneNo: member?.PhoneNo || '',
        RoleId: Number.isInteger(roleId) ? roleId : 0,
        IsActive: false,
        ImageLocation: member?.ImageLocation || '',
    }
}

// Text of a refused user/Update (403 / 409 carry Message); falls back to the given text.
export const userUpdateErrorMessage = (err, fallback) => {
    const apiErr = err?.error
    if (typeof apiErr === 'string' && apiErr.trim()) return apiErr
    return apiErr?.Message || apiErr?.ErrorMessage || apiErr?.message || fallback
}
